import { useState } from "react";
import { IMAGES } from "@/lib/brand";

export default function ImageWithFallback({ src, alt, className, ...props }) {
  const [error, setError] = useState(false);
  const finalSrc = error || !src ? IMAGES.placeholder : src;
  return (
    <img
      src={finalSrc}
      alt={alt || "BIOSYN aquaculture"}
      loading="lazy"
      onError={() => setError(true)}
      className={className}
      {...props}
    />
  );
}
